<div
  class="layout-container overflow-x-hidden"
  [ngClass]="{ dUnset: scrollPosition == 'center' }"
>

  @if(showHeader){
    <app-header [scrollData]="scrollData"></app-header>
  }
  
  @if (showTray) {
    <div class="container search-container pt-5 pb-3 mt-5">
      <div
        class="banner lazyImage"
        defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
        lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1741348664/a5ylgvr7zoxoinjq4raf.webp"
      >
        <div class="row">
          <div class="col-lg-12">
            <h4 class="text-center text-light gilroy-sb mb-3 banner-text">
              1M+ Creators
            </h4>
          </div>
          <div
            class="col-lg-7 mx-auto dCenter"
            [ngClass]="{ waitCursor: searching }"
          >
            <div class="search w-75 position-relative">
              <input
                [readOnly]="searching"
                [disabled]="searching"
                type="text"
                [(ngModel)]="mentorSearchQuery"
                (ngModelChange)="this.mentorSearchQueryUpdate.next($event)"
                class="form-control"
                style="padding-right: 2.8rem"
                placeholder="Search from Creators.."
                #search
              />
              <button
                (click)="reset()"
                [disabled]="!searchValue"
                style="overflow: visible"
                class="searchBox oHideBox dCenter bg-transparent border-0"
              >
                <fa-icon
                  [icon]="searchValue ? faTimes : faSearch"
                  [class.text-danger]="searchValue"
                  style="font-size: 20px"
                ></fa-icon>
              </button>
              <div #suggestions>
                @if (show) {
                  <app-search-suggestions
                    [searchState]="searchValue"
                    (showEmit)="reset()"
                    [show]="show"
                  ></app-search-suggestions>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layoutSticky layoutCategoryTray">
        <div class="container overflow-x-hidden">
          <div class="sideShadow mt-3 tray-container">
            @defer {
              <app-category-tray [type]="1"></app-category-tray>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
  @defer {
    <app-footer></app-footer>
  }
</div>
